export var CheckoutSdkFrameEventType;
(function (CheckoutSdkFrameEventType) {
    CheckoutSdkFrameEventType["Initialize"] = "initialize";
    CheckoutSdkFrameEventType["TokenisePaymentMethod"] = "tokenisePaymentMethod";
    CheckoutSdkFrameEventType["AuthorizePayment"] = "authorizePayment";
    CheckoutSdkFrameEventType["Change"] = "change";
    CheckoutSdkFrameEventType["PaymentRequest"] = "paymentRequest";
    CheckoutSdkFrameEventType["Error"] = "error";
    CheckoutSdkFrameEventType["Resize"] = "resize";
    CheckoutSdkFrameEventType["OpenHostAuthPopup"] = "openHostAuthPopup";
    CheckoutSdkFrameEventType["CloseHostAuthWindow"] = "closeHostAuthWindow";
    CheckoutSdkFrameEventType["PaymentComplete"] = "paymentComplete";
    CheckoutSdkFrameEventType["SetErrorMessage"] = "setErrorMessage";
    CheckoutSdkFrameEventType["CreateCustomer"] = "createCustomer";
    CheckoutSdkFrameEventType["GetGooglePayToken"] = "getGooglePayToken";
    CheckoutSdkFrameEventType["GenerateRedirectUrl"] = "generateRedirectUrl";
    CheckoutSdkFrameEventType["HandleSecureAuthentication"] = "handleSecureAuthentication";
})(CheckoutSdkFrameEventType || (CheckoutSdkFrameEventType = {}));
//# sourceMappingURL=checkout-sdk-frame-event-type.js.map